// extracted by mini-css-extract-plugin
export default {"tasks":"ER-z","task":"FR-z","svg":"GR-z","text":"HR-z"};